// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f17849d","453":"ee21dff1","455":"fd8302be","977":"c7e1bc17"}[chunkId] + ".chunk.js";
};